import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import Fade from 'react-reveal/Fade';
import Button from '@material-ui/core/Button';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSidebarContent} from '../../Content/actions';
import IconAgepPeople from '../../Layout/assets/img/icon-agep-people.svg';
import IconAgepOpenBook from '../../Layout/assets/img/icon-agep-open-book.svg';
import ImageBackground from '../assets/img/about-background.jpg';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_about';

class AboutContainer extends Component {
    section2Ref = React.createRef();

    state = {
        section2MarginLeft: 0,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        const {loading} = this.props;

        if (!loading) {
            this.props.getSidebarContent('agep_about');
        }
    }

    componentDidMount() {
        this.fetchContent();

        window.addEventListener('resize', this.setSection2Background);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setSection2Background);
    }

    componentDidUpdate(prevProps, prevState) {
        const {sidebar, loading} = this.props;

        if (sidebar.agep_about !== null && sidebar.agep_about !== undefined && !loading) {
            if (prevState.section2MarginLeft === 0) {
                this.setSection2Background();
            }
        }

        if (prevProps.languages !== this.props.languages) {
            const {pathname} = this.props.location;
            const expectedUri = this.props.translate('routes.about');

            if (pathname !== expectedUri) {
                this.props.history.push(expectedUri);
            } else {
                this.fetchContent();
            }
        }
    }

    setSection2Background = () => {
        if (this.section2Ref.current) {
            this.setState({
                section2MarginLeft: -this.section2Ref.current.offsetLeft,
            });
        }
    };

    render() {
        const {sidebar, loading} = this.props;

        const pageTitle = 'A propos de l\'Association' + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        if (sidebar.agep_about === null || sidebar.agep_about === undefined || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'about vertical-content-force-height-100'
                        }}
                    >
                        <title>{pageTitle}</title>
                    </Helmet>
                    <div className="container">
                        <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        let widgets = sidebar.agep_about.widgets;

        let imageFeatured = '';
        if (widgets.featured_image && widgets.featured_image.data.url !== '') {
            imageFeatured = widgets.featured_image.data.url;
        }

        let section2Style = {
            backgroundImage: 'url(' + ImageBackground + ')',
            marginLeft: this.state.section2MarginLeft,
        };

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'about'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <article className="about">
                        <header>
                            <div className="row no-gutters">
                                <div className="col-left col-md-7 col-sm-12">
                                    <div className="d-block d-md-none d-sm-block">
                                        {widgets.titre &&
                                            <h1>{ReactHtmlParser(widgets.titre.data.content)}</h1>
                                        }
                                    </div>
                                    <Fade>
                                        <div className="featured-image" style={{backgroundImage: 'url(' + imageFeatured + ')'}}></div>
                                    </Fade>
                                </div>
                                <div className="col-right col-md-5 col-sm-12">
                                    <div className="d-none d-sm-none d-md-block">
                                        {widgets.titre &&
                                            <h1>{ReactHtmlParser(widgets.titre.data.content)}</h1>
                                        }
                                    </div>
                                    {widgets.description &&
                                        <div className="description">{ReactHtmlParser(widgets.description.data.content)}</div>
                                    }
                                    <ul className="highlight clearfix">
                                        {(widgets.nombre_eleves && widgets.nombre_eleves.data.content !== '') &&
                                            <li>
                                                <div className="icon">
                                                    <img src={IconAgepPeople} alt=""/>
                                                </div>
                                                <div className="content">
                                                    <span className="title"><Translate id="contact.nombre_eleves" /></span>
                                                    <span className="txt">{ReactHtmlParser(widgets.nombre_eleves.data.content)}</span>
                                                </div>
                                            </li>
                                        }
                                        {(widgets.nombre_cours && widgets.nombre_cours.data.content !== '') &&
                                            <li>
                                                <div className="icon">
                                                    <img src={IconAgepOpenBook} alt=""/>
                                                </div>
                                                <div className="content">
                                                    <span className="title"><Translate id="contact.nombre_cours" /></span>
                                                    <span className="txt">{ReactHtmlParser(widgets.nombre_cours.data.content)}</span>
                                                </div>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </header>
                        <section id="section-1" className="section-title-text">
                            <div className="row row-content">
                                <div className="col-left col-lg-4 col-sm-12 offset-lg-1 offset-sm-0">
                                    {widgets.bloc1_titre &&
                                        <span className="title">
                                            {ReactHtmlParser(widgets.bloc1_titre.data.content)}
                                        </span>
                                    }
                                </div>
                                <div className="col-right col-lg-6 col-sm-12">
                                    {widgets.bloc1_contenu &&
                                        <Fragment>{ReactHtmlParser(widgets.bloc1_contenu.data.content)}</Fragment>
                                    }
                                </div>
                            </div>
                        </section>
                        <section id="section-2" ref={this.section2Ref}>
                            <div className="background" style={section2Style}></div>
                            <div className="row row-content">
                                <div className="col-10 offset-1 col-lg-7 offset-lg-1">
                                    {widgets.bloc2_titre &&
                                        <span className="title">
                                            {ReactHtmlParser(widgets.bloc2_titre.data.content)}
                                        </span>
                                    }
                                </div>
                            </div>
                        </section>
                        <section id="section-3" className="highlight-with-images">
                            <div className="row row-content">
                                <div className="col col-content col-12 col-lg-4 offset-0 offset-lg-1 align-self-center order-1 order-lg-0 order-md-1 order-sm-1">
                                    {widgets.bloc3_titre &&
                                        <h3>{ReactHtmlParser(widgets.bloc3_titre.data.content)}</h3>
                                    }
                                    <div className="content">
                                        {widgets.bloc3_contenu &&
                                            <Fragment>{ReactHtmlParser(widgets.bloc3_contenu.data.content)}</Fragment>
                                        }
                                    </div>
                                    <Button variant="contained" color="primary" className="btn-more" component={props => <Link to={this.props.translate('routes.schools')} {...props}/>}>
                                        <Translate id="contact.button_view_schools" />
                                    </Button>
                                </div>
                                <div className="col col-images col-12 col-lg-6 order-0 order-lg-1 order-md-0 order-sm-0">
                                    <Fade top>
                                        <div className="image image-1 front bottom right">
                                            {widgets.bloc3_image1 &&
                                                <img src={widgets.bloc3_image1.data.url} alt=""/>
                                            }
                                        </div>
                                    </Fade>
                                    <Fade bottom>
                                        <div className="image image-2 back top left">
                                            {widgets.bloc3_image2 &&
                                                <img src={widgets.bloc3_image2.data.url} alt=""/>
                                            }
                                        </div>
                                    </Fade>
                                </div>
                            </div>
                        </section>
                        {(widgets.hasOwnProperty('bloc4_titre') && widgets.bloc4_titre !== '' && widgets.hasOwnProperty('bloc4_contenu') && widgets.bloc4_contenu !== '') &&
                            <section id="section-4" className="section-title-text">
                                <div className="row row-content">
                                    <div className="col-left col-12 col-lg-4 offset-lg-1">
                                        {widgets.bloc4_titre &&
                                            <span className="title">
                                                {ReactHtmlParser(widgets.bloc4_titre.data.content)}
                                            </span>
                                        }
                                    </div>
                                    <div className="col-right col-12 col-lg-6">
                                        {widgets.bloc4_contenu &&
                                            <Fragment>{ReactHtmlParser(widgets.bloc4_contenu.data.content)}</Fragment>
                                        }
                                    </div>
                                </div>
                            </section>
                        }
                        {(widgets.hasOwnProperty('bloc5_titre') && widgets.bloc5_titre !== '' && widgets.hasOwnProperty('bloc5_contenu') && widgets.bloc5_contenu !== '') &&
                            <section id="section-5" className="section-title-text inverse">
                                <div className="row row-content">
                                    <div className="col-right col-12 col-lg-6 offset-lg-1 order-1 order-lg-0 order-md-1 order-sm-1">
                                        {widgets.bloc5_contenu &&
                                            <Fragment>{ReactHtmlParser(widgets.bloc5_contenu.data.content)}</Fragment>
                                        }
                                    </div>
                                    <div className="col-left col-12 col-lg-4 order-0 order-lg-1 order-md-0 order-sm-0">
                                        {widgets.bloc5_titre &&
                                        <span className="title">
                                                {ReactHtmlParser(widgets.bloc5_titre.data.content)}
                                            </span>
                                        }
                                    </div>
                                </div>
                            </section>
                        }
                        {(widgets.hasOwnProperty('bloc6_titre') && widgets.bloc6_titre !== '' && widgets.hasOwnProperty('bloc6_contenu') && widgets.bloc6_contenu !== '') &&
                            <section id="section-6" className="section-title-text">
                                <div className="row row-content">
                                    <div className="col-left col-12 col-lg-4 offset-lg-1">
                                        {widgets.bloc6_titre &&
                                            <span className="title">
                                                {ReactHtmlParser(widgets.bloc6_titre.data.content)}
                                            </span>
                                        }
                                    </div>
                                    <div className="col-right col-12 col-lg-6">
                                        {widgets.bloc6_contenu &&
                                            <Fragment>{ReactHtmlParser(widgets.bloc6_contenu.data.content)}</Fragment>
                                        }
                                    </div>
                                </div>
                            </section>
                        }
                    </article>
                </div>
            </Fragment>
        );
    }
}

AboutContainer.propTypes = {
    getSidebarContent: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    sidebar: state.content.sidebar,
    loading: state.content.sidebarLoading,
    errors: state.errors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getSidebarContent})(withLocalize(AboutContainer)));



// WEBPACK FOOTER //
// ./src/features/About/components/AboutContainer.js